import React from 'react';

export default ({ label, hint, name, className, errors = [], ...props }) => {
  return (
    <div className={className}>
      {label && (
        <label className="form-label" htmlFor={name}>
          {label}:
        </label>
      )}
      <input
        id={name}
        name={name}
        {...props}
        className={`form-input mb-2 ${errors.length ? 'error' : ''}`}
      />
      {hint && <span className='text-gray-400'>Example: {hint}</span>}
      {errors && <div className="form-error">{errors}</div>}
    </div>
  );
};
